import { safeSerialize } from '@core/utils/json';
export default (hbs, templateGlobals) => {
    hbs.registerHelper('global', function (property) {
        return templateGlobals[property];
    });
    hbs.registerHelper('css', function (property, value, fallback, options) {
        if (value) {
            return property + ': ' + value + ';';
        }
        if (typeof fallback === 'string') {
            return property + ': ' + fallback + ';';
        }
        return '';
    });
    hbs.registerHelper('attribute', function (property, value) {
        if (value) {
            return property + '="' + value + '"';
        }
        else {
            return '';
        }
    });
    hbs.registerHelper('bg_image', function (property, value) {
        if (value) {
            return property + ': url(' + value + ');';
        }
        else {
            return '';
        }
    });
    hbs.registerHelper('if_equals', function (arg1, arg2, options) {
        if ((arg1 === true || arg1 === 'true') && (arg2 === true || arg2 === 'true')) {
            return options.fn(this);
        }
        if ((arg1 === false || arg1 === 'false') && (arg2 === false || arg2 === 'false')) {
            return options.fn(this);
        }
        return arg1 == arg2 ? options.fn(this) : options.inverse(this);
    });
    hbs.registerHelper('if_in_editor', function (mode, options) {
        return ['design', 'translation'].indexOf(mode) !== -1 ? options.fn(this) : options.inverse(this);
    });
    hbs.registerHelper('if_in_view', function (mode, options) {
        return ['live', 'preview'].indexOf(mode) !== -1 ? options.fn(this) : options.inverse(this);
    });
    hbs.registerHelper('if_live', function (mode, options) {
        return mode === 'live' ? options.fn(this) : options.inverse(this);
    });
    hbs.registerHelper('if_preview', function (mode, options) {
        return mode === 'preview' ? options.fn(this) : options.inverse(this);
    });
    hbs.registerHelper('if_greater', function (arg1, arg2, options) {
        if (parseInt(arg1) > parseInt(arg2)) {
            return options.fn(this);
        }
        else {
            return options.inverse(this);
        }
    });
    // Must be prefixed with "hbs_" otherwise its not possible to create the helper in PHP
    const hbsSwitchCase = {
        switch_value: null,
        switch_break: null,
    };
    hbs.registerHelper('hbs_switch', function (value, options) {
        hbsSwitchCase.switch_value = value;
        hbsSwitchCase.switch_break = false;
        return options.fn(this);
    });
    hbs.registerHelper('hbs_case', function (value, options) {
        if (value == hbsSwitchCase.switch_value) {
            hbsSwitchCase.switch_break = true;
            return options.fn(this);
        }
    });
    hbs.registerHelper('hbs_default', function (options) {
        if (hbsSwitchCase.switch_break === false) {
            return options.fn(this);
        }
    });
    hbs.registerHelper('sum', function () {
        let result = 0;
        for (let i = 0; i < arguments.length - 1; i++) {
            result += arguments[i];
        }
        return result;
    });
    hbs.registerHelper('deviceClass', function (device) {
        if (device === 'desktop') {
            return 'pgb-desktop-only';
        }
        else if (device === 'mobile') {
            return 'pgb-mobile-only';
        }
        return '';
    });
    hbs.registerHelper('hasMultipleItems', function (array, opts) {
        if ((array || []).length > 1) {
            return opts.fn(this);
        }
        else {
            return opts.inverse(this);
        }
    });
    hbs.registerHelper('buttonStyle', function (style, color, backgroundColor, padding, options) {
        // There are no ways in CSS to lighten or darken a single color
        // So we decided to use linar gradients and background-blend-mode
        // to lighten and darken colors
        switch (style) {
            case 'cch-button-style-gradient':
                return `
            background:
              linear-gradient(0deg, rgb(80, 80, 80) 0%, rgb(160, 160, 160) 100%),
              linear-gradient(0deg, ${backgroundColor} 0%, ${backgroundColor}  100%);
            background-blend-mode: luminosity;
            color: ${color};
          `;
            case 'cch-button-style-border':
                // In this case there must be a border in the bottom of the button
                // There is no method to darken only the button, so we added a padding
                // bottom and the linear gradient.
                // Another solution would be https://css-tricks.com/css-variables-calc-rgb-enforcing-high-contrast-colors/
                // but this is a very complex solution for only these buttons.
                return `
            background:
              linear-gradient(180deg, rgb(135, 135, 135) 0%, rgb(135, 135, 135) calc(100% - 4px), rgb(95, 95, 95) 4px),
              linear-gradient(0deg, ${backgroundColor} 0%, ${backgroundColor}  100%);
            background-blend-mode: luminosity;
            padding-bottom: calc(${padding}px + 4px);
            color: ${color};
          `;
            case 'cch-button-style-ghost':
                return `
            background: transparent;
            border: 2px solid ${backgroundColor};
            color: ${backgroundColor};
          `;
            default:
                return `
            background: ${backgroundColor};
            color: ${color};
          `;
        }
    });
    hbs.registerHelper('hasSelectedChildren', function (lecture, opts) {
        if (lecture) {
            if (lecture.selected) {
                return opts.fn(this);
            }
            if (lecture.children && lecture.children.length) {
                for (let child of lecture.children) {
                    if (child.selected) {
                        return opts.fn(this);
                    }
                }
            }
        }
        return opts.inverse(this);
    });
    hbs.registerHelper('length', function (array, opts) {
        if ((array || []).length) {
            return opts.fn(this);
        }
        else {
            return opts.inverse(this);
        }
    });
    hbs.registerHelper('divide', function (a, b, opts) {
        return +a / +b;
    });
    hbs.registerHelper('subtract', function (a, b) {
        return +a - +b;
    });
    hbs.registerHelper('if_equals_or_undefined', function (value, expected, options) {
        if (value === expected || typeof value === 'undefined') {
            return options.fn(this);
        }
        return options.inverse(this);
    });
    hbs.registerHelper('rgbToRgba', function (rgb, opacity) {
        // Match the RGB values inside the parenthesis
        const match = rgb.match(/\d+/g);
        if (match && match.length === 3) {
            const [r, g, b] = match;
            return `rgba(${r}, ${g}, ${b}, ${opacity})`;
        }
        return rgb;
    });
    hbs.registerHelper('rgbaAlphaModifier', function (rgbaValue, newAlphaValue, opts) {
        return rgbaValue.replace(/rgba?\((\d+),\s*(\d+),\s*(\d+)(?:,\s*(\d+(?:\.\d+)?))?\)/i, 'rgba($1, $2, $3, ' + newAlphaValue + ')');
    });
    hbs.registerHelper('hbs_isset', function (a, opts) {
        if (typeof a !== 'undefined') {
            return opts.fn(this);
        }
        else {
            return opts.inverse(this);
        }
    });
    hbs.registerHelper('json', safeSerialize);
    hbs.registerHelper('translate', function (translations, ...args) {
        const key = args.slice(0, -1).join('');
        return translations[key] || key;
    });
    hbs.registerHelper('if_not_equals', function (arg1, arg2, options) {
        return arg1 !== arg2 ? options.fn(this) : options.inverse(this);
    });
    hbs.registerHelper('ifCond', function (v1, operator, v2, options) {
        switch (operator) {
            case '==':
                return v1 == v2 ? options.fn(this) : options.inverse(this);
            case '===':
                return v1 === v2 ? options.fn(this) : options.inverse(this);
            case '!=':
                return v1 != v2 ? options.fn(this) : options.inverse(this);
            case '!==':
                return v1 !== v2 ? options.fn(this) : options.inverse(this);
            case '<':
                return v1 < v2 ? options.fn(this) : options.inverse(this);
            case '<=':
                return v1 <= v2 ? options.fn(this) : options.inverse(this);
            case '>':
                return v1 > v2 ? options.fn(this) : options.inverse(this);
            case '>=':
                return v1 >= v2 ? options.fn(this) : options.inverse(this);
            case '&&':
                return v1 && v2 ? options.fn(this) : options.inverse(this);
            case '||':
                return v1 || v2 ? options.fn(this) : options.inverse(this);
            default:
                return options.inverse(this);
        }
    });
    hbs.registerHelper('placeholder', function (width = 1, height = 1) {
        return `data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 ${width} ${height}'%3E%3C/svg%3E`;
    });
    hbs.registerHelper('trim', function (value) {
        if (typeof value === 'string') {
            return value.trim();
        }
        return value;
    });
    hbs.registerHelper('parseFloat', function (value) {
        return parseFloat(value) || 0;
    });
    hbs.registerHelper('safeVal', function (value, safeValue) {
        return value || safeValue;
    });
    hbs.registerHelper('replaceAll', function (value, search, replace, options) {
        return value.split(search).join(replace);
    });
};
